let Widget3dsoft = require('./Main.js');

Widget3dsoft.prototype.beforeSendAjax = function (xhr, self) {
    xhr.setRequestHeader("Authorization", "BEARER " + self.sJWT);
};

/**
 * Show the form to search clients
 * @returns {undefined}
 */
Widget3dsoft.prototype.showFormSearchClient = function (sShowTab) {
    var self = this;

    this.sStep = 'stepAccueil';
    sShowTab = (sShowTab == undefined) ? 'search' : sShowTab;
    self.iNoPageSearch = 0;

    if (self.sHtmlFormSearchClient != undefined) {
        $(self.sClass).html(self.sHtmlFormSearchClient);
        self.callbackCompleteRecherche(self, sShowTab);
        self.filArianne(self, self.sStep);
        $(self.sClass + ' .widget3Dsoft-loading').hide();
        self.bAjaxTermine3Dsoft = true;
        self.adaptDimensions(self);
        self.headerProfil(self);
        

    } else {
        self.ajax('GET',
            this.sServerURL + 'widget/form-search-client' + this.sParamsGet, {},
            function (response, statut) {

                $(self.sClass).html(response);
                self.sHtmlFormSearchClient = response;
                self.callbackCompleteRecherche(self, sShowTab);
                self.filArianne(self, self.sStep);
                self.bAjaxTermine3Dsoft = true;

                if (self.sVersion != self.oSite.sVersionWidget) {
                    $('#widget_version').prepend('V' + self.sVersion);
                    $('#widget_version i').show();
                }

                self.adaptDimensions(self);
                self.headerProfil(self);


            }
        );
    }
    return false;
};

Widget3dsoft.prototype.callbackCompleteRecherche = function (self, sShowTab) {
    var sFooter = '<div class="col-lg-7 col-sm-7 col-md-7 col-xs-7 text-center pointer">';
    sFooter += '<div class="row" onClick="' + self.sVarName + '.scrollToTop(' + self.sVarName + ');" style="text-decoration:underline;">' + self.sLanguage.CLIENT_RETOUR_EN_HAUT + '</div>';
    sFooter += '</div>';

    sFooter += '<div class="col-lg-5 col-sm-5 col-md-5 col-xs-5 text-center pointer">';
    sFooter += '<div class="row"><button class="btn btn-info" onClick="' + self.sVarName + '.createNouveauClientRendezVous(' + self.sVarName + ');">' + self.sLanguage.CLIENT_BTN_NOUVEAU + '</button></div>';
    sFooter += '</div>';


    if ((self.oSearchClient.sNom != null && self.oSearchClient.sNom != '') ||
        (self.oSearchClient.sVin != null && self.oSearchClient.sVin != '') ||
        (self.oSearchClient.sImmatriculation != null && self.oSearchClient.sImmatriculation != '') ||
        (self.oSearchClient.sPrenom != null && self.oSearchClient.sPrenom != '') ||
        (self.oSearchClient.sTel != null && self.oSearchClient.sTel != '')) {

        self.searchClient(self.oSearchClient.sTel,
            self.oSearchClient.sNom,
            self.oSearchClient.sImmatriculation,
            self.oSearchClient.sPrenom,
            self.oSearchClient.sVin);

    }

    sPrenom = (self.rendezvous.sPrenom === null) ? '' : self.rendezvous.sPrenom.substr(0, 1).toUpperCase() + self.rendezvous.sPrenom.substr(1).toLowerCase();
    sNom = (self.rendezvous.sNom === null) ? '' : self.rendezvous.sNom.toUpperCase();

    $(self.sClass + ' .widget3Dsoft-nom').val(sNom);
    $(self.sClass + ' .widget3Dsoft-prenom').val(sPrenom);

    $(self.sClass + ' .widget3Dsoft-nom').keyup(function () {
        $(self.sClass + ' .widget3Dsoft-nom').val($(self.sClass + ' .widget3Dsoft-nom').val().toUpperCase());
    });

    $(self.sClass + ' .widget3Dsoft-prenom').keyup(function () {
        $(self.sClass + ' .widget3Dsoft-prenom').val($(self.sClass + ' .widget3Dsoft-prenom').val().substr(0, 1).toUpperCase() + $(self.sClass + ' .widget3Dsoft-prenom').val().substr(1).toLowerCase());
    });

    $(self.sClass + ' footer').html(sFooter);
    $(self.sClass + ' .btnSearchClient').click(function () {
        self.searchClient();
    });
    $(self.sClass + ' .toggleTabSearch').click(function () {
        self.toggleTabSearchCalendar(self, 'search');
    });
    $(self.sClass + ' .toggleTabCalendar').click(function () {
        self.toggleTabSearchCalendar(self, 'calendar');
    });

    //On press enter
    $('.form-search-client input').keypress(function (e) {
        if (e.which == 13) {
            self.searchClient();
            return false;
        }
    });

    if (sShowTab == 'calendar') {
        self.toggleTabSearchCalendar(self, 'calendar');
    }

}
/**
 * Show the form to search clients
 * @returns {undefined}
 */
Widget3dsoft.prototype.searchClient = function (sTel, sNom, sImmatriculation, sPrenom, sVin) {
    var self = this;
 
    $(self.sClass + ' .widget3Dsoft-message').hide();
    if (this.sStep == 'stepAccueil') {

        self.iNoPageSearch = 0;
        self.aSearchClientRdvs = [];
        self.aClients = [];
        //get params
        (sTel === undefined) ? sTel = $(self.sClass + ' .widget3Dsoft-tel').val(): $(self.sClass + ' .widget3Dsoft-tel').val(sTel);
        (sNom === undefined) ? sNom = $(self.sClass + ' .widget3Dsoft-nom').val(): $(self.sClass + ' .widget3Dsoft-nom').val(sNom);
        (sPrenom === undefined) ? sPrenom = $(self.sClass + ' .widget3Dsoft-prenom').val(): $(self.sClass + ' .widget3Dsoft-prenom').val(sPrenom);
        (sImmatriculation === undefined) ? sImmatriculation = $(self.sClass + ' .widget3Dsoft-immatriculation').val(): $(self.sClass + ' .widget3Dsoft-immatriculation').val(sImmatriculation);
        (sVin === undefined) ? sVin = $(self.sClass + ' .widget3Dsoft-vin').val(): $(self.sClass + ' .widget3Dsoft-vin').val(sVin);

        //If neither param is defined, we ask the user

        if ((sTel === undefined || sTel === '') &&
            (sNom === undefined || sNom === '') &&
            (sPrenom === undefined || sPrenom === '') &&
            (sImmatriculation === undefined || sImmatriculation === '') &&
            (sVin === undefined || sVin === '')) {

            $(self.sClass + ' .widget3Dsoft-message').html(self.sLanguage.CLIENT_MSG_SEARCH_FIELDS_EMPTY);
            $(self.sClass + ' .widget3Dsoft-message').show();
        }

        //We can call the webservice
        else {
            //Historicize the search infos
            self.oSearchClient.sTel = sTel;
            self.oSearchClient.sNom = sNom;
            self.oSearchClient.sPrenom = sPrenom;
            self.oSearchClient.sImmatriculation = sImmatriculation;
            self.oSearchClient.sPrenom = sPrenom;
            self.oSearchClient.sVin = sVin;

            //Keep in rendez vous object the values
            self.rendezvous.tel = sTel;
            self.rendezvous.sNom = sNom;
            self.rendezvous.sPrenom = sPrenom;
            self.rendezvous.sImmatriculation = sImmatriculation;
            self.rendezvous.vin = sVin;

            self.ajax('POST',
                this.sServerURL + 'rest/client/search' + this.sParamsGet, {
                    sClientName: self.sClientName,
                    sCfaLibelle: self.sCfaLibelle,
                    sTel: sTel,
                    sNom: sNom,
                    sPrenom: sPrenom,
                    sImmatriculation: sImmatriculation,
                    sVin: sVin
                },
                function (response) {
                    if (bIEOld3Dsoft) {
                        response = JSON.parse(response);
                    }

                    if (response.success == true) {

                        //self.toggleBlocSearch();
                        self.scrollToTop(self, self.sClass + ' .widget3Dsoft-res-searchclient');
                        //Clients

                        aClients = response.datas.aClients;

                        self.aClients = [];
                        $.each(aClients, function (iIClient, oClient) {

                            self.aClients[iIClient] = oClient;
                            self.aClients[iIClient]['aRdv'] = [];
                        });

                        aRdvsByClientId = [];
                        $.each(response.datas.aRdvs, function (iIdRdv, oRdv) {

                            if (undefined == aRdvsByClientId[oRdv._CLI_ID]) {
                                aRdvsByClientId[oRdv._CLI_ID] = [];
                            }
                            aRdvsByClientId[oRdv._CLI_ID][oRdv._RDV_ID] = oRdv;
                        });

                        $(self.sClass + ' .widget3Dsoft-res-searchclient').empty();

                        if (aClients.length == 0) {
                            $(self.sClass + ' .widget3Dsoft-res-searchclient').append(self.sLanguage.CLIENT_MSG_AUCUN_CLIENT_TROUVE);
                        } else {

                            sHtmlClients = '';

                            aRes = self.getHtmlClient(self, aClients, aRdvsByClientId);
                            sHtmlClients = aRes.sHtmlClients;
                            iCptClient = aRes.iCptClient;

                            sHtmlClients += '<div>';

                            $(self.sClass + ' .widget3Dsoft-res-searchclient').append(sHtmlClients);

                            //deployer le client s'il n'y en a qu'un
                            if (iCptClient > 0) {
                                var idFirst = $('.widget3Dsoft-res-searchclient :first-child').data('id');
                                self.toggleContentClient(idFirst);
                            } else {
                                $(self.sClass + ' .widget3Dsoft-res-afficherplus').html('<a onClick="' + self.sVarName + '.afficherplus(' + self.sVarName + ');">' + self.sLanguage.CLIENT_AFFICHER_PLUS + '</a');
                            }

                        }

                        self.aSearchClientRdvs = aRdvsByClientId;


                    } else {
                        $(self.sClass + ' .widget3Dsoft-message').html(self.sLanguage.SEARCH_CLIENT_ERROR_500);
                        $(self.sClass + ' .widget3Dsoft-message').show();
                    }
                    self.bAjaxTermine3Dsoft = true;
                    self.adaptDimensions(self);
                }, true);

        }
    } else {
        $(self.sClass + ' .widget3Dsoft-btnConfirmStopAction').click(function () {
            self.showFormSearchClient();
        });
        $(self.sClass + ' .widget3Dsoft-message-stopaction').show();
        $(self.sClass + ' article').scrollTop(0);
    }
};


Widget3dsoft.prototype.searchClientByTel = function (sTel) {
    this.searchClient(sTel, '', '', '', '');
}

Widget3dsoft.prototype.searchClientByNom = function (sNom) {
    this.searchClient('', sNom, '', '', '');
}

Widget3dsoft.prototype.searchClientByImmat = function (sImmatriculation) {
    this.searchClient('', '', sImmatriculation, '', '');
}

Widget3dsoft.prototype.searchClientByPrenom = function (sPrenom) {
    this.searchClient('', '', '', sPrenom, '');
}

Widget3dsoft.prototype.searchClientByVin = function (sVin) {
    this.searchClient('', '', '', '', sVin);
}

Widget3dsoft.prototype.getHtmlClient = function (self, aClients, aRdvsByClientId) {
    var aRes = [];
    var iCptClient = 0;
    var iFirstClient = 0;
    var aHtml = [];
    var sHtmlClients = '';

    for (key in aClients) {

        iCptClient++;
        if (iCptClient === 1) {
            iFirstClient = key;
        }

        sHtmlClients = '';
        sHtmlClients += '<div class="col-lg-12 padding-bottom-5" data-id="' + key + '" >'; //A
        sHtmlClients += '<div class="pannel">'; //B

        //Header
        sInfoBulle = self.getHtmlClientInfobulle(self, aClients, key);

        sHtmlClients += ' <div  class="pannelheader pointer" onClick="' + self.sVarName + '.toggleContentClient(' + key + ');" >'; //C

        sHtmlClients += '  <div class="text-left">'; //D

        //Infobulle
        sHtmlClients += ' <span class="infobulle' + key + ' infobulle pointer">';
        sHtmlClients += '   <span class="white pull-left padding-right-5"><span class="glyphicon glyphicon-info-sign"></span></span>'
        sHtmlClients += ' <span class="infobulleSpan' + key + ' infobulleSpan">' + sInfoBulle + '</span>';
        sHtmlClients += ' </span> ';

        sEnTete = aClients[key].nom + ' ' + aClients[key].prenom;

        if (sEnTete.length > self.iNbCaracteresNomPrenom) {
            sHtmlClients += '<span class="en_tete_nom_prenom padding-right-5">' + sEnTete.substr(0, self.iNbCaracteresNomPrenom) + '...</span>';
        } else {
            sHtmlClients += '<span class="en_tete_nom_prenom padding-right-5">' + sEnTete + '</span>';
        }

        if (aClients[key].sit_id != 0 && aClients[key].temp != 0) {
            sHtmlClients += '<i class="glyphicon glyphicon-asterisk" style="color:red;font-size:x-small;" title="Client Temporaire"></i>';
        }

        sHtmlClients += '  <div class="pull-right">'; //E
        sHtmlClients += '   <img class="arrow' + key + '" src="' + self.sServerURL + 'img/arrow-top.png"> '
        sHtmlClients += '  </div>'; //E col3
        sHtmlClients += '  </div>'; //D col7
        sHtmlClients += '</div>'; //C) pannelheader

        //Content
        sHtmlClients += ' <div class="pannelcontent pannelcontent' + key + '" style="display:none" >'; //F

        //InfosClient
        sHtmlClients += ' <div class="row">';
        sHtmlClients += ' <div class="infosClient' + key + ' col-lg-12 col-md-12 col-sm-12 col-xs-12">'; //G
        sHtmlClients += self.getHtmlClientInfos(self, aClients, key);
        sHtmlClients += '</div>'; //G) infosClient
        sHtmlClients += '</div>';

        //RdvsClient : masqués par defaut
        sHtmlClients += ' <div class="rdvsClient' + key + ' row"  style="display:none;">'; //V
        sHtmlClients += '<div class="col-lg-12 col-md-12 col-sm-12 col-xs-12">';


        for (keyRdv in aRdvsByClientId[key]) {
            sHtmlClients += '<div class="row padding-top-5 padding-bottom-5 rowdRdv' + keyRdv + '">'; //W
            if (aRdvsByClientId[key][keyRdv]._SIT_RAISON_SOCIALE !== self.oSite.sRaisonSociale) {
                sHtmlClients += '<div class="col-lg-12 col-md-12 col-sm-12 col-xs-12"><span style="color: red;"><b>' + aRdvsByClientId[key][keyRdv]._SIT_RAISON_SOCIALE + '</b></span></div>';
            }
            sHtmlClients += '<div class="col-lg-7 col-md-7 col-sm-7">'; //W1
            if (aRdvsByClientId[key][keyRdv]._SIT_RAISON_SOCIALE == self.oSite.sRaisonSociale) {
                sHtmlClients += '<a class="pointer" onClick="' + self.sVarName + '.updateRendezvous(' + self.sVarName + ',' + key + ',' + keyRdv + ')">'
                sHtmlClients += self.formatDate(aRdvsByClientId[key][keyRdv]._RDV_DATE);
                sHtmlClients += ' <img src="' + self.sServerURL + 'img/edit-icon.png">';
                sHtmlClients += '</a> ';
                sHtmlClients += ' <img style="float: right;" class="pointer" onClick="' + self.sVarName + '.deleteRendezvous(' + self.sVarName + ',' + keyRdv + ')" src="' + self.sServerURL + 'img/delete-icon.png" alt="[X]">';
            } else {
                sHtmlClients += '<a>'
                sHtmlClients += self.formatDate(aRdvsByClientId[key][keyRdv]._RDV_DATE);
                sHtmlClients += '</a> ';
            }

            sHtmlClients += '</div>'; //W1) col
            sHtmlClients += '<div class="col-lg-5 col-md-5 col-sm-5">'; //W1" style="background:' + aRdvsByClientId[key][keyRdv]._ETA_COLOR + '">';//W2
            sHtmlClients += '<div style="width:100%;background:' + aRdvsByClientId[key][keyRdv]._ETA_BACKGROUND_COLOR + ';color:' + aRdvsByClientId[key][keyRdv]._ETA_COLOR + ';">' + aRdvsByClientId[key][keyRdv]._ETA_LIBELLE + '</div>';
            sHtmlClients += '</div>'; //W2) col
            sHtmlClients += '</div>'; //W) row
        }

        sHtmlClients += ' </div>';
        sHtmlClients += ' </div>'; //V)rdvsClient


        //Lien afficher info/rdv et Btn Creer RDV
        sHtmlClients += ' <div class="row text-center padding-top-10">'; //X
        sHtmlClients += '  <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12">'; //Y
        if (aRdvsByClientId[key] != undefined) {
            sHtmlClients += '   <a class="pointer linkShowRdvs' + key + '"  onClick="' + self.sVarName + '.switchInfoClient(' + key + ')">' + self.sLanguage.CLIENT_MSG_AFFICHER_RDV + '</a>';
            sHtmlClients += '   <a class="pointer linkShowClient' + key + '" style="display:none;"  onClick="' + self.sVarName + '.switchInfoClient(' + key + ')">' + self.sLanguage.CLIENT_MSG_AFFICHER_CLIENT + '</a>';
        }

        sHtmlClients += '  </div>'; //Y) 
        sHtmlClients += '  </div>'; //X) row

        sHtmlClients += ' <div class="row text-center padding-top-10">';
        sHtmlClients += '  <div class="col-lg-6 col-md-6 col-sm-6 ">';
        sHtmlClients += '   <a class="btn btn-primary" onClick="' + self.sVarName + '.initRdv(self);' + self.sVarName + '.showFormNewClient(false,true,' + key + ');">' + self.sLanguage.CLIENT_MSG_MODIFIER_CLIENT + '</a>';
        sHtmlClients += '  </div>';
        sHtmlClients += '  <div class="col-lg-6 col-md-6 col-sm-6">';
        sHtmlClients += '   <button class="btn btn-primary" onClick="' + self.sVarName + '.initRdv(self);' + self.sVarName + '.showFormNewClient(false,false,' + key + ',true);">' + self.sLanguage.CLIENT_BTN_CREER_RENDEZVOUS + '</button>';
        sHtmlClients += '  </div>';

        sHtmlClients += ' </div>';

        sHtmlClients += '</div>'; //F) pannelcontent

        sHtmlClients += '</div>'; //A) padding-bottom-5
        sHtmlClients += '</div>'; //B) pannel
        sEnTete = sEnTete.replace(/[^a-z]/gi, '') + key;
        aHtml[sEnTete] = sHtmlClients;
    }

    aHtml = self.ksort(aHtml);
    aRes.sHtmlClients = '';

    iCptClient = 0;
    for (var sHtml in aHtml) {
        aRes.sHtmlClients += aHtml[sHtml];
        iCptClient++;
    }
    aRes.iFirstClient = iFirstClient;
    aRes.iCptClient = iCptClient;
    return aRes;
};

Widget3dsoft.prototype.ksort = function (obj) {
    var keys = Object.keys(obj).sort(),
        sortedObj = {};

    for (var i in keys) {
        sortedObj[keys[i]] = obj[keys[i]];
    }

    return sortedObj;
};

Widget3dsoft.prototype.getHtmlClientInfobulle = function (self, aClients, key) {
    var sInfoBulle = '<div class="col-lg-12 col-md-12 col-sm-12 col-xs-12"><div class="row">' + aClients[key].tel_gsm + '</div>';
    sInfoBulle += '<div class="row">' + self.sLanguage.CLIENT_EMAIL + ' : ' + aClients[key].email + '</div>';
    sInfoBulle += '<div class="row">' + self.sLanguage.CLIENT_ADRESSE + '</div>';
    sInfoBulle += '<div class="row">' + aClients[key].adresse1 + '</div>';
    sInfoBulle += '<div class="row">' + aClients[key].code_postal + ' ' + aClients[key].ville + '</div></div>';
    return sInfoBulle;
}

Widget3dsoft.prototype.getHtmlClientInfos = function (self, aClients, key) {
    var sHtmlClients = ' <div class="row padding-bottom-10">'; //A

    sHtmlClients += '  <div class="col-lg-6 col-md-6 col-sm-6">'; //B
    sHtmlClients += '       <div class="row">'; //C
    sHtmlClients += aClients[key].tel_dom;
    sHtmlClients += '       </div>'; //FIN C
    sHtmlClients += '       <div class="row">'; //D
    sHtmlClients += aClients[key].tel_gsm;
    sHtmlClients += '       </div>'; //FIN D
    sHtmlClients += '       <div class="row">'; //E
    sHtmlClients += aClients[key].email;
    sHtmlClients += '       </div>'; //FIN E
    sHtmlClients += '  </div>'; //FIN B

    sHtmlClients += '  <div class="col-lg-6 col-md-6 col-sm-6">'; //M
    sHtmlClients += '       <div class="row">'; //N
    sHtmlClients += '  <div class="col-lg-12 col-md-12 col-sm-12">' + aClients[key].adresse1 + '</div>';
    sHtmlClients += '       </div>'; //N) row
    sHtmlClients += '       <div class="row">'; //O
    sHtmlClients += '  <div class="col-lg-12 col-md-12 col-sm-12">' + aClients[key].code_postal + ' ' + aClients[key].ville + '</div>';
    sHtmlClients += '       </div>'; //O)row
    sHtmlClients += '  </div>'; //M) col5

    sHtmlClients += '</div>'; //FIN A

    //Dernier RDV
    if (aRdvsByClientId[key] != undefined) {
        oRdv = self.getLastRdv(self, aRdvsByClientId[key]);
        if (oRdv._SIT_RAISON_SOCIALE == self.oSite.sRaisonSociale) {
            sHtmlClients += ' <div class="last-rdv pointer" onClick="' + self.sVarName + '.updateRendezvous(' + self.sVarName + ',' + key + ',' + oRdv._RDV_ID + ')">'; //P
        } else {
            sHtmlClients += ' <div class="last-rdv">'; //P
        }
        sHtmlClients += ' <div class="row text-left" >'; //P

        sHtmlClients += '      <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12">';
        sHtmlClients += '           <div class="row">';
        sHtmlClients += '           <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12">';
        if (oRdv._SIT_RAISON_SOCIALE == self.oSite.sRaisonSociale) {
            sHtmlClients += '<span class="pull-right"><button class="btn btn-primary btn-xs"><span class="glyphicon glyphicon-pencil"></span> ' + self.sLanguage.VALIDATION_BTN_UPDATE + '</button></span><b>' + oRdv.oVehicule._VEH_LIBELLE_MARQUE + ' ' + oRdv.oVehicule._VEH_LIBELLE_MODELE + '</b>';
        } else {
            sHtmlClients += '<div > <b style="color: red;">Rdv pris sur ' + oRdv._SIT_RAISON_SOCIALE + '</b></div> <b>' + oRdv.oVehicule._VEH_LIBELLE_MARQUE + ' ' + oRdv.oVehicule._VEH_LIBELLE_MODELE + '</b> ';

        }

        sHtmlClients += '           </div>';
        sHtmlClients += '           </div>';
        sHtmlClients += '           <div class="row padding-top-10">';
        sHtmlClients += '           <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12">';
        sHtmlClients += '               <b>' + self.sLanguage.DATES_RECEPTION + ' : </b> ' + self.formatDate(oRdv._RDV_DATE + ' ' + self.convertMinutesToHHMM(oRdv._RDV_HEURE_ARRIVEE));
        sHtmlClients += '           </div>';
        sHtmlClients += '           </div>';
        sHtmlClients += '           <div class="row">';
        sHtmlClients += '           <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12">';
        sHtmlClients += '               <b>' + self.sLanguage.DATES_RESTITUTION + ' : </b> ' + self.formatDate(oRdv._RDV_DATE_RESTITUTION + ' ' + self.convertMinutesToHHMM(oRdv._RDV_HEURE_RESTITUTION));
        sHtmlClients += '           </div>';
        sHtmlClients += '           </div>';
        sHtmlClients += '     </div>';

        sHtmlClients += ' </div>';


        if (oRdv._INTERVENTIONS_LIST[0] != undefined && oRdv._INTERVENTIONS_LIST.length > 0) {
            sHtmlClients += '     <div class="row padding-top-5">';
            sHtmlClients += '      <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12">' + oRdv._INTERVENTIONS_LIST[0]._INT_LIBELLE + '</div>';
            sHtmlClients += '     </div>';
        }

        if (oRdv._RDV_EN_ATTENTE == 1) {
            sHtmlClients += '     <div class="row padding-top-5">';
            sHtmlClients += '      <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12"><img width="16" height="16" src="' + self.sServerURL + 'img/panneau_stop.png"> ' + self.sLanguage.CLIENT_MSG_RDV_EN_ATTENTE + ' (' + oRdv.oIndicateur.sLibelle + ')</div>';
            sHtmlClients += '     </div>';
        }

        if (oRdv._RDV_LE_CLIENT_ATTENDS == 1) {
            //le client attend
            sHtmlClients += ' <div class="row padding-top-5">'; //T
            sHtmlClients += ' <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12 bg-orange">';
            sHtmlClients += '  <img width="16" height="16" src="' + self.sServerURL + 'img/ClientAttend.png"> ' + self.sLanguage.CLIENT_MSG_RDV_CLIENT_EN_ATTENTE;
            sHtmlClients += ' </div>';
            sHtmlClients += ' </div>';
        }

        if (oRdv._RDV_VEHICULE_REMPLACEMENT == 1) {
            //le clietn attend
            sHtmlClients += ' <div class="row padding-top-5">'; //T
            sHtmlClients += ' <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12 bg-orange">';
            sHtmlClients += '  <img width="16" height="16" src="' + self.sServerURL + 'img/VK.bmp"> ' + self.sLanguage.DATES_VEHICULE_COURTOISIE;
            sHtmlClients += ' </div>';
            sHtmlClients += ' </div>';
        }

        sHtmlClients += '     </div>'; //T)

        sHtmlClients += ' <div class="row text-center" >';
        sHtmlClients += '     <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12">';
        sHtmlClients += '<div style="width:100%;background:' + oRdv._ETA_BACKGROUND_COLOR + ';color:' + oRdv._ETA_COLOR + ';">' + oRdv._ETA_LIBELLE + '</div>';
        sHtmlClients += '     </div>';
        sHtmlClients += ' </div>';

    } else {
        sHtmlClients += ' <div class="row">'; //P
        sHtmlClients += '  <div class="col-lg-12 col-md-12 col-sm-12">'; //W1">';//U
        sHtmlClients += ' <div class="last-rdv" style="width:100%;">' + self.sLanguage.CLIENT_MSG_PAS_DE_RENDEZVOUS + '</div>';
        sHtmlClients += ' </div>'; //U) col10
        sHtmlClients += '  </div>'; //P)row
    }
    return sHtmlClients;
};

Widget3dsoft.prototype.afficherplus = function (self) {
    self.iNoPageSearch++;
    //get params
    var sTel = $(self.sClass + ' .widget3Dsoft-tel').val();
    var sNom = $(self.sClass + ' .widget3Dsoft-nom').val();
    var sPrenom = $(self.sClass + ' .widget3Dsoft-prenom').val();
    var sImmatriculation = $(self.sClass + ' .widget3Dsoft-immatriculation').val();
    var sVin = $(self.sClass + ' .widget3Dsoft-vin').val();

    //If neither param is defined, we ask the user

    if ((sTel === undefined || sTel === '') &&
        (sNom === undefined || sNom === '') &&
        (sImmatriculation === undefined || sImmatriculation === '') &&
        (sVin === undefined || sVin === '')) {

        $(self.sClass + ' .widget3Dsoft-message').html(self.sLanguage.CLIENT_MSG_SEARCH_FIELDS_EMPTY);
        $(self.sClass + ' .widget3Dsoft-message').show();
    }

    //We can call the webservice
    else {

        self.rendezvous.tel = sTel;
        self.rendezvous.sNom = sNom;
        self.rendezvous.sPrenom = sPrenom;
        self.rendezvous.sImmatriculation = sImmatriculation;
        self.rendezvous.vin = sVin;

        self.ajax('POST',
            this.sServerURL + 'rest/client/search' + this.sParamsGet, {
                sClientName: self.sClientName,
                sCfaLibelle: self.sCfaLibelle,
                sTel: sTel,
                sNom: sNom,
                sPrenom: sPrenom,
                sImmatriculation: sImmatriculation,
                sVin: sVin,
                iNoPage: self.iNoPageSearch
            },
            function (response) {
                if (bIEOld3Dsoft) {
                    response = JSON.parse(response);
                }
                if (response.success == true) {

                    //Clients

                    aClients = response.datas.aClients;

                    $.each(aClients, function (iIClient, oClient) {

                        self.aClients[iIClient] = oClient;
                    });

                    aRdvsByClientId = response.datas.aRdvs;


                    if (aClients.length == 0) {
                        $(self.sClass + ' .widget3Dsoft-res-afficherplus').html(self.sLanguage.CLIENT_MSG_FIN_RESULTAT);
                    } else {
                        //$(self.sClass + ' .widget3Dsoft-res-searchclient').empty();
                        aRes = self.getHtmlClient(self, aClients, aRdvsByClientId);
                        sHtmlClients = aRes.sHtmlClients;
                        iCptClient = aRes.iCptClient;
                        $(self.sClass + ' .widget3Dsoft-res-searchclient').append(sHtmlClients);


                    }

                    $.each(aRdvsByClientId, function (iIdRdv, oRdv) {
                        self.aSearchClientRdvs[iIdRdv] = oRdv;
                    });
                }
                self.bAjaxTermine3Dsoft = true;
                self.adaptDimensions(self);
            }, true
        );

    }
}

/**
 * Return the rdv with the highest date
 * @param {type} aRdvs
 * @returns {widget3Dsoft.getLastRdv.aRdvs}
 */
Widget3dsoft.prototype.getLastRdv = function (self, aRdvs) {
    //self = this;
    var sDateMax = null;
    var iRdvMax = null;
    for (iIdRdv in aRdvs) {
        if (sDateMax == null ||
            self.isDateSup(aRdvs[iIdRdv]._RDV_DATE, sDateMax)) {
            sDateMax = aRdvs[iIdRdv]._RDV_DATE;
            iRdvMax = iIdRdv;
        }
    }
    return aRdvs[iRdvMax];
}

/**
 * 
 * @param {type} key
 * @returns {undefined}
 */
Widget3dsoft.prototype.switchInfoClient = function (key) {
    var self = this;
    $(self.sClass + ' .infosClient' + key).toggle();
    $(self.sClass + ' .rdvsClient' + key).toggle();
    $(self.sClass + ' .linkShowClient' + key).toggle();
    $(self.sClass + ' .linkShowRdvs' + key).toggle();
};

/**
 * 
 * @param iIdClient iIdClient
 * @param widget3Dsoft self
 * @returns {undefined}
 */
Widget3dsoft.prototype.changeClient = function (iIdClient, self) {

    $(self.sClass + ' .widget3Dsoft-res-rdv').empty();

    var aCurentRdvs = self.aSearchClientRdvs[iIdClient]; //Get his rendezvous

    //If there is nothing in 
    if (aCurentRdvs === undefined) {
        $(self.sClass + ' .widget3Dsoft-res-rdv').append('<p>' + self.sLanguage.CLIENT_MSG_PAS_DE_RENDEZVOUS + '</p>');
    } else if (aCurentRdvs._RDV_DATE === undefined) {

        $(self.sClass + ' .widget3Dsoft-res-rdv').append('<ul>');
        for (key in aCurentRdvs) {
            $(self.sClass + ' .widget3Dsoft-res-rdv').append('<li>' + self.formatDate(aCurentRdvs[key]._RDV_DATE) + '</li>');
        }
        $(self.sClass + ' .widget3Dsoft-res-rdv').append('</ul>');

    } else {
        $(self.sClass + ' .widget3Dsoft-res-rdv').html('<ul>');
        $(self.sClass + ' .widget3Dsoft-res-rdv').append('<li>' + self.formatDate(aCurentRdvs._RDV_DATE) + '</li>');
        $(self.sClass + ' .widget3Dsoft-res-rdv').append('</ul>');

    }
};

/**
 * 
 * @param {type} key
 * @returns {undefined}
 */
Widget3dsoft.prototype.toggleContentClient = function (key) {
    var self = this;
    if ($(self.sClass + ' .arrow' + key).attr('src') == self.sServerURL + 'img/arrow-top.png') {
        $(self.sClass + ' .arrow' + key).attr('src', self.sServerURL + 'img/arrow-bottom.png');
    } else {
        $(self.sClass + ' .arrow' + key).attr('src', self.sServerURL + 'img/arrow-top.png');
    }
    $(self.sClass + ' .pannelcontent' + key).toggle();
    //$("#infobulleSpan" + key).toggleClass('infobulleSpan');
    //$("#infobulleSpan" + key).toggleClass('bloc-hidden');

};

Widget3dsoft.prototype.toggleTabSearchCalendar = function (self, sTab) {

    if (sTab == 'search') {
        $(self.sClass + ' .widget3Dsoft-client-tab-recherche').addClass('active');
        $(self.sClass + ' .widget3Dsoft-client-tab-calendar').removeClass('active');
        $(self.sClass + ' .widget3Dsoft-blocSearch').show();
        $(self.sClass + ' .widget3Dsoft-blocCalendar').hide();
    } else {
        $(self.sClass + ' .widget3Dsoft-client-tab-recherche').removeClass('active');
        $(self.sClass + ' .widget3Dsoft-client-tab-calendar').addClass('active');
        $(self.sClass + ' .widget3Dsoft-blocSearch').hide();
        $(self.sClass + ' .widget3Dsoft-blocCalendar').show();

        if ($(self.sClass + ' .widget3Dsoft-atelier').val() === null) {
            self.showAteliers(self, function () {
                self.showCalendarReception(self, '', '');
            });
        }
    }

}